import toast from "react-hot-toast";
import classes from "./EditDelivery.module.css";
import ModalWrapper from "../modalWrapper/ModalWrapper";
import WhitePlusIcon from "../../images/deliveries/whitePlusIcon.svg";
import SearchableDropdown from "../searchableDropdown/SearchableDropdown";
import { ActionBtn } from "../buttons/actionBtn/ActionBtn";
import { useLocation } from "react-router-dom";
import { InputElement } from "../inputElement/InputElement";
import { fetchDrivers } from "../../redux/driver/thunks/getDriverThunk";
import { cancelPackage } from "../../redux/package/thunks/cancelPackageThunk";
import { updatePackage } from "../../redux/package/thunks/updatePackageThunk";
import { InputCheckbox } from "../inputCheckbox/InputCheckbox";
import { LoadingSpinner } from "../loadingSpinner/LoadingSpinner";
import { createDelivery } from "../../redux/package/thunks/createDeliveryThunk";
import { fetchCustomers } from "../../redux/customer/thunks/getCustomerThunk";
import { getCurrentDate } from "../../helperFunctions/getCurrentDate";
import { RepeatDelivery } from "../repeatDelivery/RepeatDelivery";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { useStatusEffect } from "../../helperFunctions/customHooks/useStatusEffect";
import { fetchDeliveries } from "../../redux/package/thunks/getDeliveryThunk";
import { fetchDepartments } from "../../redux/department/thunks/getDepartmentThunk";
import { fetchCustomerById } from "../../redux/customer/thunks/getCustomerByIdThunk";
import { resetCustomersState } from "../../redux/customer/slices/getCustomerSlice";
import { useEffect, useState } from "react";
import { getScheduledDeliveries } from "../../redux/package/scheduledPackages/getScheduledDeliveries";
import { validateRequiredFields } from "../../helperFunctions/validateRequiredFields";
import { resetCancelPackageStatus } from "../../redux/package/slices/cancelPackageSlice";
import { useDispatch, useSelector } from "react-redux";
import { resetCreatePackageStatus } from "../../redux/package/slices/createDeliverySlice";
import { resetUpdatePackageStatus } from "../../redux/package/slices/updatePackageSlice";
import { resetCreateCustomerStatus } from "../../redux/customer/slices/createCustomerSlice";
import {
  createScheduledDelivery,
  resetCreateScheduledDeliveryStatus,
} from "../../redux/package/scheduledPackages/createScheduledDelivery";
import {
  onEdit,
  setIsAddNewCustomerAddress,
  setIsEditModalShown,
  setIsAddLaundry,
  setIsMapShown,
  setSelectedDriverInfo,
  setIsNewPickupAddressCreated,
  setIsNewCustomerCreated,
  setShouldResetData,
  setShouldResetScheduledPackage,
} from "../../redux/globalFunctions/globalFnSlice";
import {
  resetPackageForm,
  setPackageForm,
} from "../../redux/forms/packageForm";
import {
  resetUpdateScheduledDeliveryStatus,
  updateScheduledDelivery,
} from "../../redux/package/scheduledPackages/updateScheduledDelivery";

export function EditDelivery() {
  // Variables for redux state.
  const {
    isEditMode,
    selectedDataForEdit,
    selectedDriverInfo,
    isNewPickupAddressCreated,
    isNewCustomerCreated,
    shouldResetData,
    shouldResetScheduledPackage,
  } = useSelector((state) => state.global);
  const { drivers, status: getDriversStatus } = useSelector(
    (state) => state.drivers
  );
  const formData = useSelector((state) => state.forms.packageForm);
  const departments = useSelector((state) => state.departments);
  const customersState = useSelector((state) => state.customers);
  const updatePackageState = useSelector((state) => state.updatePackage);
  const cancelPackageState = useSelector((state) => state.cancelDelivery);
  const createDeliveryState = useSelector((state) => state.createDelivery);
  const createScheduledDeliveryState = useSelector(
    (state) => state.scheduledDeliveries.createScheduledDelivery
  );
  const updateScheduledDeliveryState = useSelector(
    (state) => state.scheduledDeliveries.updateScheduledDelivery
  );

  const dispatch = useDispatch();
  const location = useLocation();

  const [id, setId] = useState("");
  const [driverName, setDriverName] = useState("");
  const [dropoffName, setDropoffName] = useState("");
  const [isScheduledActive, setIsScheduledActive] = useState(true);
  const [pickupNameToDisplay, setPickupNameToDisplay] = useState("");

  const { t } = useTranslations();
  const modalText = t.addDeliveryModal;
  const validationText = t.formValidations;

  const isLocationScheduled = location.pathname === "/scheduled-deliveries";
  const isLocationDeliveries = location.pathname === "/deliveries";
  const isLocationDashboard = location.pathname === "/dashboard";

  useEffect(() => {
    dispatch(fetchDrivers({ names_only: true }));
  }, []);

  useEffect(() => {
    if (
      customersState.status === "succeeded" &&
      customersState.customer_names.length === 1
    ) {
      setDropoffName(customersState.customers[0].c_address);
      dispatch(
        setPackageForm({
          addCustomer: customersState.customers[0].c_id,
          dropoff: isLocationScheduled
            ? customersState.customers[0].c_id
            : customersState.customers[0].c_lid,
        })
      );
    }
  }, [customersState.status]);

  useEffect(() => {
    if (
      departments.status === "succeeded" &&
      departments.department_names.length === 1
    ) {
      setPickupNameToDisplay(departments.departments[0].d_address);
      dispatch(
        setPackageForm({
          pickup: isLocationScheduled
            ? departments.departments[0].d_id
            : departments.departments[0].d_lid,
        })
      );
    }
  }, [departments.status]);

  useEffect(() => {
    if (getDriversStatus === "succeeded" && drivers.length === 1) {
      setDriverName(drivers[0].u_firstname + " " + drivers[0].u_lastname);
      dispatch(
        setPackageForm({
          driver: drivers[0].u_id,
        })
      );
    }
  }, [getDriversStatus]);

  useEffect(() => {
    if (formData.pickup) {
      const selectedDept = departments.department_names.find(
        (dept) =>
          (isLocationDeliveries || isLocationDashboard
            ? dept.d_lid
            : dept.d_id) === formData.pickup
      );

      if (selectedDept) {
        setPickupNameToDisplay(selectedDept.d_address);
      } else {
        setPickupNameToDisplay("");
      }
    }
  }, [formData.pickup, departments.department_names]);

  // Determine if we should allow full editing or limited editing based on status
  const isLimitedEdit =
    isEditMode &&
    (selectedDataForEdit?.status === "Picked" ||
      selectedDataForEdit?.status === "Delivered" ||
      selectedDataForEdit?.status === "Cancelled");

  const isLimitedEditCancelBtn =
    isEditMode &&
    (selectedDataForEdit?.status === "Accepted" ||
      selectedDataForEdit?.status === "Delivered" ||
      selectedDataForEdit?.status === "Cancelled");

  // Fetch results if customer or departments length is 0.
  useEffect(() => {
    dispatch(fetchCustomers({ per_page: 1 }));
    dispatch(fetchDepartments({ per_page: 1 }));
  }, []);

  // Refetch data if customer id is changed.
  useEffect(() => {
    if (id) {
      dispatch(fetchCustomerById({ customer_id: id }));
    }
  }, [id]);

  // Combine firstname and lastname in one variable.
  const selectedDriverName =
    selectedDriverInfo &&
    selectedDriverInfo.u_firstname + " " + selectedDriverInfo.u_lastname;

  useEffect(() => {
    const { pd_height, pd_width, pd_depth } = formData;

    if (pd_height && pd_width && pd_depth) {
      const h = parseFloat(pd_height);
      const w = parseFloat(pd_width);
      const d = parseFloat(pd_depth);

      if ([h, w, d].every((num) => !isNaN(num) && num > 0)) {
        const volume = h * w * d; // m³
        const volumeCm3 = Math.round(volume * 1_000_000); // cm³ (integer)

        handleInputChange({
          target: { name: "pd_volume", value: volumeCm3 },
        });
      } else {
        handleInputChange({ target: { name: "pd_volume", value: "" } });
      }
    } else {
      handleInputChange({ target: { name: "pd_volume", value: "" } });
    }
  }, [formData.pd_height, formData.pd_width, formData.pd_depth]);

  // Handle input changes
  const handleInputChange = (e, id) => {
    const { name, value } = e.target;
    dispatch(setPackageForm({ [name]: value }));
    if (name === "addCustomer") {
      setId(id);
    }
  };

  useEffect(() => {
    if (isEditMode && selectedDataForEdit) {
      if (isLocationDeliveries) {
        setDropoffName(selectedDataForEdit.dropoff_address_name);
        setDriverName(selectedDataForEdit.driver.name);
      } else if (isLocationScheduled) {
        setIsScheduledActive(selectedDataForEdit.ds_active === 1);
        setDropoffName(selectedDataForEdit.customer_address);
        setDriverName(
          selectedDataForEdit.driver_firstname
            ? selectedDataForEdit.driver_firstname +
                " " +
                selectedDataForEdit.driver_lastname
            : ""
        );
      } else {
        setDropoffName("");
        setDriverName(
          selectedDataForEdit.driver_firstname +
            " " +
            selectedDataForEdit.driver_lastname
        );
      }
    }
  }, [isEditMode, selectedDataForEdit, location.pathname]);

  function formatDateToYYYYMMDD(dateInput) {
    const dateObj =
      typeof dateInput === "string" ? new Date(dateInput) : dateInput;
    return dateObj?.toISOString().split("T")[0];
  }

  // Prefill form if in edit mode
  useEffect(() => {
    if (isEditMode && selectedDataForEdit && shouldResetData) {
      if (isLocationDeliveries) {
        const {
          driver,
          pickup_address,
          dropoff_address,
          pd_width,
          pd_height,
          pd_depth,
          pd_volume,
          order_date,
          pickup_address_name,
          dropoff_address_name,
        } = selectedDataForEdit;

        dispatch(setShouldResetData(false));
        const customer = customersState.customer_names.find(
          (customer) => customer.c_name === selectedDataForEdit.customer.name
        );

        setPickupNameToDisplay(pickup_address_name);
        setDropoffName(dropoff_address_name);
        setDriverName(driver.name);
        dispatch(
          setPackageForm({
            addCustomer: customer ? customer.c_id : "",
            driver: driver.id || "",
            pickup: pickup_address || "",
            dropoff: dropoff_address || "",
            date: order_date || "",
            pd_width: pd_width,
            pd_height: pd_height,
            pd_depth: pd_depth,
            pd_volume: pd_volume,
          })
        );
      } else if (isLocationScheduled) {
        const {
          ds_driverID,
          ds_did,
          ds_pickup_id,
          ds_dtstart,
          customer_address,
          customer_name,
          ds_rrule,
        } = selectedDataForEdit;

        const customer = customersState.customer_names.find(
          (customer) => customer.c_name === customer_name
        );

        setDropoffName(customer_address);

        dispatch(
          setPackageForm({
            addCustomer: customer ? customer.c_id : "",
            driver: ds_driverID || "",
            pickup: ds_pickup_id || "",
            dropoff: ds_did || "",
            pd_width: "",
            pd_height: "",
            pd_depth: "",
            pd_volume: "",
            ends: ds_rrule.custom.end.type === "never" ? "never" : "until",
            everyType:
              ds_rrule.mode.charAt(0).toUpperCase() + ds_rrule.mode.slice(1),
            everyNumber: String(ds_rrule.custom?.bymonthday?.[0] ?? "") || "",
            startDate: formatDateToYYYYMMDD(ds_dtstart),
            date: formatDateToYYYYMMDD(ds_dtstart),
            selectedWeekdays: ds_rrule.custom.byweekday,
            endDate: formatDateToYYYYMMDD(ds_rrule.custom?.end?.until_utc),
          })
        );
      }
    }
  }, [isEditMode, selectedDataForEdit, shouldResetData, location]);

  // Function for changing the driver name.
  useEffect(() => {
    if (selectedDriverInfo) {
      setDriverName(selectedDriverName);
      dispatch(
        setPackageForm({
          driver: selectedDriverInfo && selectedDriverInfo.dr_uid,
        })
      );
    }
  }, [selectedDriverInfo]);

  // Function for canceling a package.
  function handleCancelPackage() {
    dispatch(cancelPackage({ package_id: selectedDataForEdit.package_id }));
  }

  useStatusEffect({
    status: cancelPackageState.status,
    onSuccess: onEdit,
    successMessage: modalText.successCanceled,
    resetStatus: resetCancelPackageStatus,
    errorMessage: modalText.failedCanceling + " " + cancelPackageState.error,
    onError: onEdit,
    reFetch: fetchDeliveries,
  });

  useStatusEffect({
    status: updatePackageState.status,
    onSuccess: onEdit,
    successMessage: modalText.successUpdated,
    resetStatus: resetUpdatePackageStatus,
    errorMessage: modalText.failedUpdating + " " + updatePackageState.error,
    onError: onEdit,
    reFetch: fetchDeliveries,
    resetForm: resetPackageForm,
  });

  useStatusEffect({
    status: createDeliveryState.status,
    onSuccess: onEdit,
    successMessage: modalText.successCreated,
    resetStatus: resetCreatePackageStatus,
    errorMessage: modalText.failedCreating + " " + createDeliveryState.error,
    onError: onEdit,
    reFetch: fetchDeliveries,
    resetForm: resetPackageForm,
  });

  useStatusEffect({
    status: createScheduledDeliveryState.status,
    onSuccess: onEdit,
    successMessage: modalText.successCreatedScheduled,
    resetStatus: resetCreateScheduledDeliveryStatus,
    errorMessage:
      modalText.failedCreatingScheduled +
      " " +
      createScheduledDeliveryState.error,
    onError: onEdit,
    reFetch: getScheduledDeliveries,
    resetForm: resetPackageForm,
  });

  useStatusEffect({
    status: updateScheduledDeliveryState.status,
    onSuccess: onEdit,
    successMessage: modalText.successUpdatedScheduled,
    resetStatus: resetUpdateScheduledDeliveryStatus,
    errorMessage:
      modalText.failedUpdatingScheduled +
      " " +
      createScheduledDeliveryState.error,
    onError: onEdit,
    reFetch: getScheduledDeliveries,
    resetForm: resetPackageForm,
  });

  // Handler for updatePackageState statuses
  useEffect(() => {
    const { status } = updatePackageState;
    if (
      status === "success" ||
      status === "error" ||
      shouldResetScheduledPackage
    ) {
      handleResetForm();
      dispatch(setShouldResetData(true));
      dispatch(setShouldResetScheduledPackage(false));
    }
  }, [updatePackageState.status, dispatch, shouldResetScheduledPackage]);

  // Handler for createDeliveryState statuses
  useEffect(() => {
    if (
      createDeliveryState.status === "success" ||
      createScheduledDeliveryState.status === "success"
    ) {
      handleResetForm();
    }
  }, [
    createDeliveryState.status,
    dispatch,
    createScheduledDeliveryState.status,
  ]);

  // Update dropoff address when a customer is fetched
  useEffect(() => {
    const { customer } = customersState;

    if (customer && customer.c_address) {
      setDropoffName(customer.c_address);
      dispatch(
        setPackageForm({
          dropoff:
            isLocationDeliveries || isLocationDashboard
              ? customer.c_lid
              : customer.c_id,
        })
      );
    }
  }, [customersState.customer, isNewCustomerCreated]);

  function handleCloseModal() {
    if (isEditMode) {
      dispatch(resetPackageForm());
      dispatch(setSelectedDriverInfo(""));
      setDropoffName("");
      dispatch(resetCustomersState());
    }
    dispatch(setShouldResetData(true));
    dispatch(onEdit());
    setPickupNameToDisplay("");
  }

  const headerText = isLocationScheduled
    ? isEditMode
      ? modalText.updateScheduleDelivery
      : modalText.scheduleDelivery
    : isEditMode
    ? modalText.editText
    : modalText.addText;

  const isBtnDisabled =
    createDeliveryState.status === "loading" ||
    updatePackageState.status === "loading";

  useEffect(() => {
    if (isNewPickupAddressCreated) {
      const lastAddressIndex = departments.department_names.length - 1;
      dispatch(
        setPackageForm({
          pickup:
            isLocationDeliveries || isLocationDashboard
              ? departments?.department_names[lastAddressIndex]?.d_lid
              : departments?.department_names[lastAddressIndex]?.d_id,
        })
      );
      setTimeout(() => {
        dispatch(setIsNewPickupAddressCreated(false));
      }, 1000);
    }
  }, [isNewPickupAddressCreated, departments]);

  useEffect(() => {
    if (isNewCustomerCreated) {
      const lastCustomerIndex = customersState.customer_names.length - 1;
      setId(customersState?.customer_names[lastCustomerIndex]?.c_id);
      dispatch(
        setPackageForm({
          addCustomer: customersState?.customer_names[lastCustomerIndex]?.c_id,
        })
      );
      setTimeout(() => {
        dispatch(setIsNewCustomerCreated(false));
      }, 1000);
    }
  }, [isNewCustomerCreated, customersState]);

  function handleResetForm() {
    setPickupNameToDisplay("");
    dispatch(setIsNewCustomerCreated(false));
    dispatch(resetCreateCustomerStatus());
    dispatch(resetPackageForm());
    dispatch(resetCustomersState());
    setDropoffName("");
    setDriverName("");
    dispatch(setSelectedDriverInfo(""));
  }

  function handleSelectDriver(e) {
    e.stopPropagation();
    dispatch(setIsMapShown(true));
    dispatch(setIsEditModalShown(false));
  }

  function handleCreateNewAddress() {
    dispatch(setIsAddLaundry(true));
    dispatch(setIsEditModalShown(false));
  }

  function handleCreateNewCustomer() {
    dispatch(setIsAddNewCustomerAddress(true));
    dispatch(setIsEditModalShown(false));
  }

  const allFormDataFieldsEmpty = Object.values(formData).every(
    (value) => value === ""
  );

  // Check if the input fields are empty to disable the submit button
  const requiredFields = isLimitedEdit
    ? []
    : isLocationScheduled
    ? [
        "addCustomer",
        "pickup",
        "date",
        ...(formData.everyType === "Monthly" && formData.everyType !== ""
          ? ["everyNumber"]
          : []),
        "everyType",
        "ends",
        ...(formData.ends !== "never" && formData.ends !== ""
          ? ["endDate"]
          : []),
        ...(formData.everyType === "Weekly" && formData.everyType !== ""
          ? ["selectedWeekdays"]
          : []),
      ]
    : ["addCustomer", "pickup", "date"];

  function handleSubmit(e) {
    e.preventDefault();

    // Validate required fields
    const errors = validateRequiredFields(
      formData,
      requiredFields,
      validationText
    );

    if (errors.length > 0) {
      toast.dismiss();
      setTimeout(() => {
        errors.forEach((err) =>
          toast.error(err, {
            duration: 2000,
          })
        );
      }, 100);
      return;
    }
    if (!isLocationScheduled) {
      const {
        date,
        pd_height,
        pd_width,
        pd_depth,
        pd_volume,
        driver,
        addCustomer,
        dropoff,
        pickup,
      } = formData;

      if (isEditMode && isLocationDeliveries) {
        const updateData = {
          package_id: selectedDataForEdit.package_id,
          order_date: date === "" ? null : date,
          pd_height: parseFloat(pd_height),
          pd_width: parseFloat(pd_width),
          pd_depth: parseFloat(pd_depth),
          pd_volume: parseFloat(pd_volume),
          status: driver ? 6 : 8,
          driverID: driver ? +driver : null,
          customerID: +addCustomer,
          dropoff_address: dropoff,
          pickup_address: pickup,
        };

        dispatch(updatePackage(updateData));
      } else {
        const newDeliveryData = {
          driverID: driver ? +driver : null,
          customerID: +addCustomer,
          dropoff_address: dropoff,
          order_date: date,
          pickup_address: pickup,
          status: driver ? 6 : 8,
          pd_height: parseFloat(pd_height),
          pd_width: parseFloat(pd_width),
          pd_depth: parseFloat(pd_depth),
          pd_volume: parseFloat(pd_volume),
        };

        dispatch(createDelivery(newDeliveryData));
      }
    } else if (!isEditMode && isLocationScheduled) {
      dispatch(
        createScheduledDelivery({
          driverID: formData.driver ? formData.driver : null,
          customerID: formData.addCustomer,
          dropoff_address: formData.dropoff,
          pickup_address: formData.pickup,
          startDate: formData.date,
          interval: formData.everyNumber,
          freq: formData.everyType,
          bymonthday: formData.everyNumber,
          endsType: formData.ends,
          selectedWeekdays: formData.selectedWeekdays || [],
          endDate: formData.endDate,
          ds_active: isScheduledActive,
        })
      );
    } else if (isEditMode && isLocationScheduled) {
      dispatch(
        updateScheduledDelivery({
          ds_id: selectedDataForEdit.ds_id,
          driverID: formData.driver ? formData.driver : null,
          customerID: formData.addCustomer,
          dropoff_address: formData.dropoff,
          pickup_address: formData.pickup,
          ds_active: isScheduledActive,
        })
      );
    }
  }

  function handleNumberKeyDown(e) {
    const allowedPattern = /^[0-9]*[.,]?[0-9]*$/;

    if (e.key === "e" || e.key === "E") {
      e.preventDefault();
      return;
    }

    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Tab"
    ) {
      return;
    }

    const value = e.target.value;
    const selectionStart = e.target.selectionStart;
    const selectionEnd = e.target.selectionEnd;

    const newValue =
      value.substring(0, selectionStart) +
      e.key +
      value.substring(selectionEnd);

    if (!allowedPattern.test(newValue)) {
      e.preventDefault();
    }
  }

  const showLoadingSpinnerBtn =
    createDeliveryState.status === "loading" ||
    updatePackageState.status === "loading" ||
    createScheduledDeliveryState.status === "loading" ||
    updateScheduledDeliveryState.status === "loading";

  const dateLabel =
    isLocationDeliveries || isLocationDashboard
      ? modalText.form.date
      : modalText.form.startDate;

  function removeDriver() {
    if (isLimitedEdit) return;
    setDriverName("");
    dispatch(setPackageForm({ driver: null }));
    dispatch(setSelectedDriverInfo(null));
  }

  return (
    <ModalWrapper
      onClick={handleCloseModal}
      title={headerText}
      width={"900px"}
      onSubmit={handleSubmit}
      resetButton={
        <ActionBtn
          onClick={handleResetForm}
          disabled={allFormDataFieldsEmpty || isEditMode}
          text={modalText.reset}
        />
      }
    >
      <section className={classes.gridContainer}>
        <SearchableDropdown
          idForLabel={modalText.form.customer}
          options={customersState.customer_names
            .slice()
            .sort((a, b) => b.number_orders - a.number_orders)
            .map((customer) => ({
              value: customer.c_id,
              label: customer.c_name,
            }))}
          placeholder={modalText.selectName}
          onSelect={(value) =>
            handleInputChange({ target: { name: "addCustomer", value } }, value)
          }
          value={formData.addCustomer}
          disabled={isLimitedEdit}
          mandatory={true}
        />
        <div className={classes.dropoffSelectContainer}>
          <div className={classes.dropoffAddressDiv}>
            <label htmlFor="dropoff">
              {modalText.form.dropoff}&nbsp;
              <span style={{ color: "red" }}>*</span>
            </label>
            <span>{dropoffName}</span>
          </div>
          <ActionBtn
            onClick={handleCreateNewCustomer}
            imgSrc={WhitePlusIcon}
            text={modalText.form.newBtn}
            disabled={isLimitedEdit}
          />
        </div>
        <SearchableDropdown
          idForLabel={modalText.form.pickupName}
          options={departments.department_names.map((department) => ({
            value:
              isLocationDeliveries || isLocationDashboard
                ? department.d_lid
                : department.d_id,
            label: `${department.d_name}`,
          }))}
          placeholder={modalText.selectName}
          onSelect={(value) => {
            handleInputChange({ target: { name: "pickup", value } });
          }}
          value={formData.pickup}
          disabled={isLimitedEdit}
          mandatory={true}
        />
        <div className={classes.dropoffSelectContainer}>
          <div className={classes.dropoffAddressDiv}>
            <label htmlFor="pickup">
              {modalText.form.pickup}&nbsp;
              <span style={{ color: "red" }}>*</span>
            </label>
            <span>{pickupNameToDisplay}</span>
          </div>
          <ActionBtn
            onClick={handleCreateNewAddress}
            imgSrc={WhitePlusIcon}
            text={modalText.form.newBtn}
            disabled={isLimitedEdit}
          />
        </div>
        <InputElement
          type={"date"}
          labelText={dateLabel}
          disabled={isLimitedEdit || (isLocationScheduled && isEditMode)}
          name={"date"}
          id={"date"}
          value={formData?.date}
          onChange={handleInputChange}
          required={true}
          min={getCurrentDate()}
        />
        <div
          className={`${classes.selectDriverContainer} ${
            isLimitedEdit ? classes.disabledContainer : ""
          }`}
          onClick={(e) => {
            if (!isLimitedEdit) handleSelectDriver(e);
          }}
        >
          <div>
            <label>{modalText.form.driver}</label>
            <p>{driverName ? driverName : modalText.selectDriver}</p>
          </div>
          <ActionBtn
            onClick={(e) => {
              e.stopPropagation();
              if (driverName) {
                removeDriver();
              } else {
                handleSelectDriver(e);
              }
            }}
            text={
              driverName ? modalText.removeDriver : modalText.form.selectDriver
            }
            disabled={isLimitedEdit}
          />
        </div>
        {isLocationScheduled && (
          <InputCheckbox
            checked={isScheduledActive}
            onChange={() => setIsScheduledActive(!isScheduledActive)}
            label={modalText.active}
          />
        )}
      </section>
      {(isLocationDeliveries || isLocationDashboard) && (
        <section>
          <h5 className={classes.packageDimensions}>
            {modalText.packageDimensions}
          </h5>
          <div className={classes.dimensions}>
            <InputElement
              name="pd_width"
              id="pd_width"
              labelText={modalText.width}
              onChange={handleInputChange}
              value={formData?.pd_width}
              type={"number"}
              onKeyDown={handleNumberKeyDown}
            />
            <InputElement
              name="pd_height"
              id="pd_height"
              labelText={modalText.height}
              onChange={handleInputChange}
              value={formData?.pd_height}
              type={"number"}
              onKeyDown={handleNumberKeyDown}
            />
            <InputElement
              name="pd_depth"
              id="pd_depth"
              labelText={modalText.depth}
              onChange={handleInputChange}
              value={formData?.pd_depth}
              type={"number"}
              onKeyDown={handleNumberKeyDown}
            />
            <InputElement
              disabled={true}
              name="pd_volume"
              id="pd_volume"
              labelText={modalText.volume}
              value={formData?.pd_volume}
              readOnly={true}
            />
          </div>
        </section>
      )}

      {isLocationScheduled && <RepeatDelivery />}

      <div className={classes.newDeliveryBtns}>
        {isEditMode && !isLocationScheduled && (
          <ActionBtn
            btnType="cancel"
            onClick={() => handleCancelPackage()}
            disabled={
              cancelPackageState.status === "loading" || isLimitedEditCancelBtn
            }
            text={
              cancelPackageState.status === "loading" ? (
                <LoadingSpinner black={true} />
              ) : (
                modalText.cancel
              )
            }
          />
        )}

        <ActionBtn
          height={"42px"}
          width={"100%"}
          onClick={handleSubmit}
          disabled={isBtnDisabled || isLimitedEdit}
          text={showLoadingSpinnerBtn ? <LoadingSpinner /> : modalText.save}
        />
      </div>
    </ModalWrapper>
  );
}
